export class Equipment_Extra {
  id = '';
  serial_Num = '';
  make = '';
  is_Hoist = true;
}
